import Agenda from "@/pages/Agenda";
import Assistentes from "@/pages/Assistentes";
import AssistenteNovo from "@/pages/AssistenteNovo";
import AssistenteEditar from "@/pages/AssistenteEditar";
import Campaigns from "@/pages/Campaigns";
import Chat from "@/pages/Chat";
import Fluxos from "@/pages/Fluxos";
import FluxoEditor from "@/pages/FluxoEditor";
import FollowUps from "@/pages/FollowUps";
import FollowUpEditor from "@/pages/FollowUpEditor";
import Contacts from "@/pages/Contacts";
import ImportarContatos from "@/pages/ImportarContatos";
import Crm from "@/pages/Crm";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import Notifications from "@/pages/Notifications";
import ApiKeys from "@/pages/ApiKeys";
import AccessContacts from "@/pages/AccessContacts";
import Agency from "@/pages/Agency";
import Debug from "@/pages/Debug";
import CheckCron from "@/pages/CheckCron";
import CheckScheduledMessages from "@/pages/CheckScheduledMessages";
import DebugFollowUp from "@/pages/DebugFollowUp";
import TestError from "@/pages/TestError";
import Relatorios from "@/pages/relatorios/Relatorios";
import EntradaLeadsReport from "@/pages/relatorios/EntradaLeadsReport";
import VendasReport from "@/pages/relatorios/VendasReport";
import VendasVendedorReport from "@/pages/relatorios/VendasVendedorReport";
import TempoRespostaReport from "@/pages/relatorios/TempoRespostaReport";
import VendasCampanhaReport from "@/pages/relatorios/VendasCampanhaReport";
import PerformanceMarketingReport from "@/pages/relatorios/PerformanceMarketingReport";
import AgendamentosIaReport from "@/pages/relatorios/AgendamentosIaReport";
import * as Icons from "../components/ui/shared/Icons";
import type { PermissionArea } from "@/hooks/usePermissions";
import { ConnectionGuard } from "@/components/ui/shared/layout/ConnectionGuard";
import { BarChart3, Repeat, Workflow } from "lucide-react";

export interface NavigationItem {
  icon: React.ReactNode;
  title: string;
  path: string;
  permission?: PermissionArea;
  children?: NavigationItem[];
  comingSoon?: boolean;
}

export interface RouteConfig {
  path: string;
  element: React.ReactElement;
  permission?: PermissionArea;
  title?: string;
}

export const LeftNavigationData: NavigationItem[] = [
  {
    icon: <Icons.dashboard className="w-[12px] h-[12px]" />,
    title: "Dashboard",
    path: "/",
    permission: "dashboard",
  },
  {
    icon: <Icons.contact className="w-[17px] h-[17px]" />,
    title: "Contatos",
    path: "/contacts",
    permission: "contatos",
  },
  {
    icon: <Icons.chat className="w-[14px] h-[14px]" />,
    title: "Chat",
    path: "/chat",
    permission: "chat",
  },
  {
    icon: <Icons.dashboard className="w-[12px] h-[12px]" />,
    title: "CRM",
    path: "/crm",
    permission: "crm",
  },
  {
    icon: <Icons.agenda className="w-[16px] h-[16px]" />,
    title: "Agenda",
    path: "/agenda",
    permission: "agenda",
  },
  {
    icon: <Icons.assistance className="w-[17px] h-[17px]" />,
    title: "Assistentes",
    path: "/assistentes",
    permission: "assistentes",
  },
  {
    icon: <Workflow className="h-[17px] w-[17px]" />,
    title: "Fluxos",
    path: "/fluxos",
  },
  {
    icon: <Repeat className="h-[17px] w-[17px]" />,
    title: "Follow-ups",
    path: "/follow-ups",
  },
  {
    icon: <Icons.compains className="w-[19px] h-[19px]" />,
    title: "Campanhas",
    path: "/campanhas",
    permission: "campanhas",
  },
  {
    icon: <BarChart3 className="h-[17px] w-[17px]" />,
    title: "Relatórios",
    path: "/relatorios",
    permission: "relatorios",
    comingSoon: true,
    children: [
      { icon: <span />, title: "Visão geral", path: "/relatorios", permission: "relatorios" },
      { icon: <span />, title: "Entrada de leads", path: "/relatorios/entrada-leads", permission: "relatorios" },
      { icon: <span />, title: "Vendas e perdas", path: "/relatorios/vendas", permission: "relatorios" },
      { icon: <span />, title: "Vendas por vendedor", path: "/relatorios/vendas-vendedor", permission: "relatorios" },
      { icon: <span />, title: "Tempo de resposta", path: "/relatorios/tempo-resposta", permission: "relatorios" },
      { icon: <span />, title: "Vendas por campanha", path: "/relatorios/vendas-campanha", permission: "relatorios" },
      { icon: <span />, title: "Performance de Marketing", path: "/relatorios/performance-marketing", permission: "relatorios" },
      { icon: <span />, title: "Agendamentos da IA", path: "/relatorios/agendamentos-ia", permission: "relatorios" },
    ],
  },
];

export const SettingsNavigationData: NavigationItem[] = [
  {
    icon: <Icons.settings className="w-[16px] h-[16px]" />,
    title: "Configurações",
    path: "/settings",
    permission: "configuracoes",
  },
  {
    icon: <Icons.logout className="w-[16px] h-[16px]" />,
    title: "Log out",
    path: "/login",
  },
];

export const AuthenticatedRoutes: RouteConfig[] = [
  { path: "/", element: <Dashboard />, permission: "dashboard", title: "Dashboard" },
  { path: "/contacts", element: <Contacts />, permission: "contatos", title: "Contatos" },
  { path: "/contacts/importar", element: <ImportarContatos />, permission: "contatos", title: "Importar Contatos" },
  { path: "/chat", element: <ConnectionGuard><Chat /></ConnectionGuard>, permission: "chat", title: "Chat" },
  { path: "/chat/:contactId", element: <ConnectionGuard><Chat /></ConnectionGuard>, permission: "chat", title: "Chat" },
  { path: "/crm", element: <Crm />, permission: "crm", title: "CRM" },
  { path: "/crm/:contactId", element: <AccessContacts />, permission: "crm", title: "Detalhes do Contato" },
  { path: "/agenda", element: <Agenda />, permission: "agenda", title: "Agenda" },
  { path: "/assistentes", element: <Assistentes />, permission: "assistentes", title: "Assistentes" },
  { path: "/assistentes/novo", element: <AssistenteNovo />, permission: "assistentes", title: "Novo Assistente" },
  { path: "/assistentes/editar/:id", element: <AssistenteEditar />, permission: "assistentes", title: "Editar Assistente" },
  { path: "/campanhas", element: <Campaigns />, permission: "campanhas", title: "Campanhas" },
  { path: "/relatorios", element: <Relatorios />, permission: "relatorios", title: "Relatórios" },
  { path: "/relatorios/entrada-leads", element: <EntradaLeadsReport />, permission: "relatorios", title: "Entrada de leads" },
  { path: "/relatorios/vendas", element: <VendasReport />, permission: "relatorios", title: "Vendas e perdas" },
  { path: "/relatorios/vendas-vendedor", element: <VendasVendedorReport />, permission: "relatorios", title: "Vendas por vendedor" },
  { path: "/relatorios/tempo-resposta", element: <TempoRespostaReport />, permission: "relatorios", title: "Tempo de resposta" },
  { path: "/relatorios/vendas-campanha", element: <VendasCampanhaReport />, permission: "relatorios", title: "Vendas por campanha" },
  { path: "/relatorios/performance-marketing", element: <PerformanceMarketingReport />, permission: "relatorios", title: "Performance de Marketing" },
  { path: "/relatorios/agendamentos-ia", element: <AgendamentosIaReport />, permission: "relatorios", title: "Agendamentos da IA" },
  { path: "/fluxos", element: <Fluxos />, title: "Fluxos" },
  { path: "/fluxos/novo", element: <FluxoEditor />, title: "Novo Fluxo" },
  { path: "/fluxos/editar/:id", element: <FluxoEditor />, title: "Editar Fluxo" },
  { path: "/follow-ups", element: <FollowUps />, title: "Follow-ups" },
  { path: "/follow-ups/novo", element: <FollowUpEditor />, title: "Nova Sequência" },
  { path: "/follow-ups/editar/:id", element: <FollowUpEditor />, title: "Editar Sequência" },
  { path: "/settings", element: <Settings />, permission: "configuracoes", title: "Configurações" },
  // Hub completo: acessível pelo sino do navbar, fora do menu lateral.
  { path: "/notifications", element: <Notifications />, title: "Notificações" },
  // Rota secreta: gestão de Chaves de API. Fora de qualquer menu, acessível só por URL direta.
  { path: "/painel-chaves-api", element: <ApiKeys />, permission: "configuracoes", title: "Chaves de API" },
  { path: "/agency", element: <Agency />, permission: "configuracoes", title: "Agência" },
  { path: "/debug", element: <Debug />, title: "Debug" },
  { path: "/check-cron", element: <CheckCron />, title: "Check Cron" },
  { path: "/check-scheduled-messages", element: <CheckScheduledMessages />, title: "Check Mensagens Agendadas" },
  { path: "/debug-followup", element: <DebugFollowUp />, title: "Debug Follow-up" },
  { path: "/test-error", element: <TestError />, title: "Test Error" },
];
